import React, { useState, memo } from 'react';
import cls from 'classnames';

const LiveSessionPreviewImage = ({ previewUrl }) => {
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    return (
        <>
            <img
                src={previewUrl}
                className={cls('preview-image', {'hide': !isImageLoaded})}
                alt="Live session preview"
                onLoad={() => setIsImageLoaded(true)}
            />
            {!isImageLoaded && <i className="preview-image-spinner fa fa-spinner fa-spin fa-2x" />}
        </>
    );
};

export default memo(LiveSessionPreviewImage);
